import * as React from 'react';
import LoadSuccessButton, { Props, Status } from 'Shared/UI/LoadSuccessButton';
export { Status };

const InviteButton = (props: Props) =>
  <LoadSuccessButton {...props}
    className="button theme__primary-bg challenge-invite__button" />;

export default InviteButton;
